import React, { useRef, useEffect } from 'react';

const CandlestickChart = ({ data }) => {
    const canvasRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        const width = canvas.width;
        const height = canvas.height;
        const padding = 50;
        const chartWidth = width - 2 * padding;
        const chartHeight = height - 2 * padding;

        // Clear the canvas
        ctx.clearRect(0, 0, width, height);

        // Draw axes
        ctx.beginPath();
        ctx.moveTo(padding, padding);
        ctx.lineTo(padding, height - padding);
        ctx.lineTo(width - padding, height - padding);
        ctx.stroke();

        // Calculate the scale
        const maxPrice = Math.max(...data.map(d => d.h));
        const minPrice = Math.min(...data.map(d => d.l));
        const priceRange = maxPrice - minPrice;
        const dayWidth = chartWidth / data.length;

        // Draw candlesticks
        data.forEach((d, i) => {
            const x = padding + i * dayWidth + dayWidth / 2;
            const openY = padding + chartHeight * (1 - (d.o - minPrice) / priceRange);
            const closeY = padding + chartHeight * (1 - (d.c - minPrice) / priceRange);
            const highY = padding + chartHeight * (1 - (d.h - minPrice) / priceRange);
            const lowY = padding + chartHeight * (1 - (d.l - minPrice) / priceRange);

            // Draw high-low line
            ctx.beginPath();
            ctx.moveTo(x, highY);
            ctx.lineTo(x, lowY);
            ctx.stroke();

            // Draw open-close rectangle
            ctx.fillStyle = d.c > d.o ? 'green' : 'red';
            ctx.fillRect(x - dayWidth / 4, Math.min(openY, closeY), dayWidth / 2, Math.abs(closeY - openY));
        });

        // Draw x-axis labels (dates)
        ctx.textAlign = 'center';
        ctx.textBaseline = 'top';
        data.forEach((d, i) => {
            const x = padding + i * dayWidth + dayWidth / 2;
            const date = new Date(d.x);
            const dateString = `${date.getMonth() + 1}/${date.getDate()}`;
            ctx.fillText(dateString, x, height - padding + 5);
        });
    }, [data]);

    return <canvas ref={canvasRef} width={800} height={400}></canvas>;
};

export default CandlestickChart;